import { getCookie } from 'cookies-next/client';

import { getVideoType } from '@sola/utils/video.ts';

import { oneTrust } from './consent.ts';

export type TrackingVideoInfo = {
  width: number;
  height: number;
  duration: number;
  thumbnailUrl: string;
  title: string;
  uploadDate: string;
};

export const cookieFree = (
  getOptanonConsent?: string,
  getOptanonAlertBoxClosed?: string,
): boolean => {
  if (getOptanonAlertBoxClosed) {
    if (
      !getOptanonConsent?.includes(oneTrust.targetingCookiesOptOut) &&
      !getOptanonConsent?.includes(oneTrust.peformanceCookiesOptOut)
    ) {
      return false;
    }
  }
  if (!getOptanonAlertBoxClosed) {
    return false;
  }
  return true;
};

export const cookielessVideoString = (video: string): string => {
  let videoString = video;
  const videoType = getVideoType(video);
  if (videoType === 'youtube') {
    videoString = videoString.replace('https://', '').replace('www.', '');
    videoString = videoString.replace(
      'youtube.com/watch?v=',
      'https://www.youtube-nocookie.com/embed/',
    );
    videoString = videoString.replace(
      'youtu.be/',
      'https://www.youtube-nocookie.com/embed/',
    );
    videoString = videoString.replace(
      'youtube.com/embed/',
      'https://www.youtube-nocookie.com/embed/',
    );
    return videoString;
  }
  if (videoType === 'vimeo') {
    if (videoString.includes('?')) {
      videoString += '&DNT=true';
    } else {
      videoString += '?DNT=true';
    }
    return videoString;
  }
  return videoString;
};

export const cookieConsentVideoURL = (video: string): string => {
  let videoString = video;
  const requireCookieLessEmbed = cookieFree(
    getCookie('OptanonConsent'),
    getCookie('OptanonAlertBoxClosed'),
  );
  if (requireCookieLessEmbed === false) {
    return videoString;
  }

  videoString = cookielessVideoString(videoString);

  return videoString;
};
